class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
			})
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle)

/*
 * Herbaris mobile menu (Q4 2026).
 *
 * The drawer opens under the site header instead of over it: its top edge is
 * set to the header's bottom edge, so the announcement bar, logo and icons stay
 * in view, and the hamburger turns into the close button. Categories open as
 * an accordion, one at a time.
 */
;(() => {
	const drawer = document.getElementById('Drawer-MobileNav')
	if (!drawer || drawer.dataset.hbMnavReady) return
	drawer.dataset.hbMnavReady = 'true'

	const toggleSelector = '.mobile-nav-toggle button'
	const header = () => document.querySelector('.site-header')

	const placeUnderHeader = () => {
		const el = header()
		const bottom = el ? Math.max(0, Math.round(el.getBoundingClientRect().bottom)) : 0
		drawer.style.setProperty('--hb-mnav-top', `${bottom}px`)
	}

	const setToggleState = (open) => {
		document.querySelectorAll(toggleSelector).forEach((button) => {
			button.setAttribute('aria-expanded', open ? 'true' : 'false')
		})
	}

	drawer.addEventListener('open', () => {
		placeUnderHeader()
		document.body.classList.add('hb-nav-open')
		setToggleState(true)
	})

	drawer.addEventListener('close', () => {
		document.body.classList.remove('hb-nav-open')
		setToggleState(false)
	})

	window.addEventListener('resize', () => {
		if (drawer.hasAttribute('open')) placeUnderHeader()
	})

	// While the drawer is open the hamburger closes it. This runs in the capture
	// phase so the theme's drawer-opener never sees the click and reopens it.
	document.addEventListener(
		'click',
		(event) => {
			const button = event.target.closest(toggleSelector)
			if (!button || !drawer.hasAttribute('open')) return
			event.preventDefault()
			event.stopPropagation()
			drawer.closeDrawer()
		},
		true
	)

	// Category accordion.
	drawer.addEventListener('click', (event) => {
		const toggle = event.target.closest('[data-hb-mnav-toggle]')
		if (!toggle) return

		const panel = document.getElementById(toggle.getAttribute('aria-controls'))
		const willOpen = toggle.getAttribute('aria-expanded') !== 'true'

		drawer.querySelectorAll('[data-hb-mnav-toggle][aria-expanded="true"]').forEach((other) => {
			if (other === toggle) return
			other.setAttribute('aria-expanded', 'false')
			const otherPanel = document.getElementById(other.getAttribute('aria-controls'))
			if (otherPanel) otherPanel.hidden = true
		})

		toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false')
		if (panel) panel.hidden = !willOpen
	})
})()
